module.exports = {
  title: '商品分类设置',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'goods-classify-form',
    },
  },
};
